<template>
    <v-dialog
        v-model    = "value"
        :max-width = "500"
        persistent
    >
        <v-card>
            <v-card-title v-html="$t('inc.attach.overwrite.query')"></v-card-title>
            <v-card-text  v-html="$t('inc.attach.overwrite.text')"></v-card-text>

            <v-card-actions>
                <v-btn
                    @click = "onCancel"
                    color  = "primary"
                    text
                >
                    {{ $t('common.cancel') }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                    @click = "onAttach"
                    color  = "primary"
                    text
                >
                    {{ $t('common.no') }}
                </v-btn>
                <v-btn
                    @click = "onAttachOverwrite"
                    color  = "primary"
                    text
                >
                    {{ $t('common.yes') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "DAttachConfirm",

    props: {
        value: {

        },

        data: {

        }
    },

    data: () => ({
    }),

    methods: {
        onAttach () {
            console.log("onAttach", this.data)
            this.$emit("attach", {
                overwrite: false,
                data     : this.data
            });

            this.$emit("input", false);
        },

        onAttachOverwrite () {
            this.$emit("attach", {
                overwrite: true,
                data     : this.data
            });

            this.$emit("input", false);
        },

        onCancel () {
            this.$emit("cancel");
            this.$emit("input", false);
        }
    }
}
</script>

<style scoped>

</style>